<template>
  <div>
     <v-dialog
        v-model="dialog"
        style="width:auto;"
        width="unset"
        v-if="selectedFile !== null"
      >
        <v-card :width="selectedSize" style="margin:0 auto;">
          <v-row no-gutters wrap>
            <v-col xs9 pl-2>
              <v-card-title  class="headline">
                <!--<textarea style="width:100%; resize: none;" @change="fileNameChanged($event.target.value)" :value="filesMap[selectedFile.id].name" />-->
              </v-card-title>
            </v-col>
            <v-col v-if="selectedFile.filetype !== 'pdf'" xs3 pr-3 mt-3 style="text-align:right">
              <v-btn-toggle sizeMandatory=true style="border:1px #ccc solid;" v-model="selectedSize">
                <v-btn value="1024">
                  1024
                </v-btn>
                <v-btn style="border-left:1px #ccc solid;" value="512">
                  512
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row no-gutters wrap>
            <v-col>
              <div style="margin-bottom:5px; font-weight:bold;">Kuvaus:</div>
              <input type="text" v-model="prompt_text" placeholder="Kuvan kuvauksen pyyntö" style="border: 1px solid #ccc; padding: 5px; width: 100%; margin-bottom: 10px;" />
              <v-btn @click="generateImage(selectedFile)">Luo promokuva</v-btn>
            </v-col>
          </v-row>

          <div v-if="selectedFile.filetype !== 'pdf' && selectedFile.filetype !== 'svg'">
            <div style="margin-left:20px">
              <span style="font-weight:bold">1024px</span><v-icon style="margin-left:5px; margin-right:20px;" @click="imagePrint(selectedFile.thumbnail1024Url);" size=18>fas fa-print</v-icon>
              <span style="font-weight:bold">512px</span><v-icon style="margin-left:5px" @click="imagePrint(selectedFile.thumbnail512Url);" size=18>fas fa-print</v-icon>
            </div>
            <v-img
              :width="selectedSize"
              :src="selectedSize == 1024 ? selectedFile.thumbnail1024Url : selectedFile.thumbnail512Url"
              :lazy-src="selectedFile.thumbnail128Url"
              v-on:load="diaglodImageLoaded = true"
            />
          </div>
          <div v-if="selectedFile.filetype === 'svg'">
            <v-img
              :width="selectedSize"
              :src="selectedFile.rawUrl"
              :lazy-src="selectedFile.rawUrl"
              v-on:load="diaglodImageLoaded = true"
            />
          </div>
          <div v-if="selectedFile.filetype === 'pdf'">
            <div style="margin-left:20px">
              <v-icon v-if="page > 1" @click.stop="page -= 1" size=18>far fa-arrow-alt-circle-left</v-icon>
              <v-icon v-if="page == 1" size=18 style="color:#aaa">far fa-arrow-alt-circle-left</v-icon>
              <v-icon v-if="page < numPages" style="margin-left:6px" @click.stop="page += 1;" size=18>far fa-arrow-alt-circle-right</v-icon>
              <v-icon v-if="page >= numPages" style="margin-left:6px; color:#aaa" size=18>far fa-arrow-alt-circle-right</v-icon>
              <!--<v-icon v-if="page == 1" size=14 syle="color:#aaa">far fa-arrow-alt-circle-left</v-icon>-->
              
              <v-icon style="margin-left:20px" @click="$refs.pdf.print(100, [page])" size=18>fas fa-print</v-icon>
              <input style="margin-left:20px; width: 2em;text-align:center" v-model.number="page" type="number" > /{{numPages}}
            </div>
            <pdf 
              ref="pdf"
              style="width:100%"
              @num-pages="numPages = $event"
              @link-clicked="page = $event"
              :page="page"
              :src="selectedFile.rawUrl">
            </pdf>
          </div>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import axios from 'axios'
import { saveAs } from 'file-saver';
import download  from "downloadjs"

export default {
  
  props: ['selectedFile'],
  components:{
    pdf
  },
  data: () => ({
    sizeMandatory:true,
    prompt_text:"Luo promokuva tästä tuotteesta. Kuvan tulisi houkutella asiakasta klikkaamaan.",
    selectedSize:"512",
    filetype:"",
    dialog:false,
    pdfDialog:false,
    selectedFilelUrl:"",
    selectedFileName:"",
    searchTerm: '',
    miniVariant: true,
    miniVariantRight: true,
    right: true,
    rightDrawer: true,
    clipped: true,
    loaded:false,
    diaglodImageLoaded:false,
    numPages: 0,
    page: 1,
    files: [],
    drafts:[],
    productImages:[],
    logos:[],
    promotionImages:[],
    filesMap : {},
    logosMap : {},
    draftsMap: {},
    productImagesMap: {}
  }),
  mounted() {
    
  },
  watch: {
    selectedFile: {
      handler: function (val) {
        console.log(val)
        if(val === "") this.dialog = false
        else this.dialog = true
      },
      deep: true
    }
  },
  computed: {
  },
  created () {},
  methods: {
    
    copyToClipboard (text) {
      this.$clipboard(text)
      this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kuvan URL kopioitu.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
    },
    imageSourcetoPrint(source){
      return "<html><head><style>@page { size: auto;  margin: 0mm 0mm 0mm 0mm; } .image {text-align:center;} body {margin:0px;}</style><script>function step1(){\n" +
				"setTimeout('step2()', 10); }\n" +  //
				"function step2(){window.print();window.close()}\n" +
				"</scri" + "pt></head><body onload='step1()'>\n" +
				"<div class='image'><img src='" + source + "' /></div></body></html>";
    },
    imagePrint(source) {
      var Pagelink = "about:blank";
      var pwa = window.open(Pagelink, "_new");
      pwa.document.open();
      pwa.document.write(this.imageSourcetoPrint(source));
      pwa.document.close();
    },
    
    downloadFile(file){
      var x=new XMLHttpRequest();
      x.open( "GET", file.rawUrl , true);
      x.responseType="blob";
      x.onload= function(e){download(e.target.response, file.name+"."+file.filetype);};
      x.send();
    },
    
    

    
  }
}
</script>


<style>
  
</style>



// WEBPACK FOOTER //
// src/components/blocks/MediaViewer.vue